import { Bell, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePushNotifications } from "@/hooks/usePushNotifications";
import { useIdentity } from "@/auth/identity";
import { isBlockedForNoRole } from "@/auth/claims";

export function PushNotificationPrompt() {
  const {
    shouldShowPrompt,
    isLoading,
    enableNotifications,
    markAsAsked,
  } = usePushNotifications();
  const { user, provider } = useIdentity();

  // Sin acceso (token sin rol) no se ofrece: la API rechazaría el alta del dispositivo.
  if (!shouldShowPrompt || isBlockedForNoRole(provider, user, import.meta.env.VITE_AUTH0_AUDIENCE)) {
    return null;
  }

  return (
    <div className="fixed bottom-20 left-4 right-4 z-50 animate-in slide-in-from-bottom-4 duration-300">
      <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-4">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-10 h-10 bg-primary-soft rounded-full flex items-center justify-center">
            <Bell className="w-5 h-5 text-primary" />
          </div>
          
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-gray-900 text-sm">
              Activar notificaciones
            </h3>
            <p className="text-gray-500 text-xs mt-0.5">
              Recibí alertas cuando te asignen una nueva ruta
            </p>
            
            <div className="flex gap-2 mt-3">
              <Button
                size="sm"
                onClick={enableNotifications}
                disabled={isLoading}
                className="bg-primary hover:bg-primary/90 text-white text-xs px-4"
              >
                {isLoading ? "Activando..." : "Activar"}
              </Button>
              <Button
                size="sm"
                variant="ghost"
                onClick={markAsAsked}
                disabled={isLoading}
                className="text-gray-500 text-xs"
              >
                Ahora no
              </Button>
            </div>
          </div>

          <button
            onClick={markAsAsked}
            className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Cerrar"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}

